import React from 'react'
import EditPeople from '../People/EditPeople'

const EditStudent = () => <EditPeople kind="student" />

export default EditStudent
